var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 2.7C11.2 2.3134 11.5134 2 11.9 2H14.5C14.8866 2 15.2 2.3134 15.2 2.7C15.2 3.0866 14.8866 3.4 14.5 3.4H12.6V4.4C12.6 4.7866 12.2866 5.1 11.9 5.1C11.5134 5.1 11.2 4.7866 11.2 4.4V2.7Z",
    fill: "#F3725D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.405 3.90502C11.6734 3.6366 12.1069 3.63104 12.3821 3.8925L16.3821 7.6925C16.5212 7.82465 16.6 8.00812 16.6 8.2V12.5C16.6 12.8866 16.2866 13.2 15.9 13.2C15.5134 13.2 15.2 12.8866 15.2 12.5V8.50052L11.9125 5.37742L8.79999 8.48995V12.5C8.79999 12.8866 8.48659 13.2 8.09999 13.2C7.71339 13.2 7.39999 12.8866 7.39999 12.5V8.2C7.39999 8.01435 7.47374 7.8363 7.60502 7.70502L11.405 3.90502Z",
    fill: "#12A5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8089 18.9C8.8089 17.2011 10.3358 15.7089 12.1 15.7089C13.846 15.7089 15.3911 17.0836 15.3911 18.9V22.2C15.3911 22.5817 15.0817 22.8911 14.7 22.8911H9.5C9.11831 22.8911 8.8089 22.5817 8.8089 22.2V18.9ZM12.1 17.0911C11.0642 17.0911 10.1911 17.9989 10.1911 18.9V21.5089H14.0089V18.9C14.0089 17.9164 13.154 17.0911 12.1 17.0911Z",
    fill: "#F3725D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2 10.5C18.2 10.1134 18.5134 9.8 18.9 9.8H21.5C21.8866 9.8 22.2 10.1134 22.2 10.5V22.2C22.2 22.5866 21.8866 22.9 21.5 22.9H2.7C2.3134 22.9 2 22.5866 2 22.2V10.9C2 10.5134 2.3134 10.2 2.7 10.2H5.3C5.6866 10.2 6 10.5134 6 10.9V13H7.4V10.7C7.4 10.3134 7.7134 10 8.1 10H10.5C10.8866 10 11.2 10.3134 11.2 10.7V13H12.7V10.7C12.7 10.3134 13.0134 10 13.4 10H15.9C16.2866 10 16.6 10.3134 16.6 10.7V13H18.2V10.5ZM19.6 11.2V13.7C19.6 14.0866 19.2866 14.4 18.9 14.4H15.9C15.5134 14.4 15.2 14.0866 15.2 13.7V11.4H14.1V13.7C14.1 14.0866 13.7866 14.4 13.4 14.4H10.5C10.1134 14.4 9.8 14.0866 9.8 13.7V11.4H8.8V13.7C8.8 14.0866 8.4866 14.4 8.1 14.4H5.3C4.9134 14.4 4.6 14.0866 4.6 13.7V11.6H3.4V21.5H20.8V11.2H19.6Z",
    fill: "#15A5B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2,
    height: 20.9,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.1a7b15f6bdb0a21b8f90261f3c35758c.svg";
export { ForwardRef as ReactComponent };